import { COLORS } from 'shared/constants/theme';
import themeFactory from '../helpers/themeFactory';

export default themeFactory({
  backgroundColor: 'transparent',
  borderColor: 'transparent',
  color: COLORS.black,
  textDecoration: 'underline'
});
